import { Injectable } from '@angular/core';
import axios from 'axios';
import { UnidadGroup} from './../../common/interfaces/unidad.interface';
import { AuthService } from '@services/auth/auth.service';
import { BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { Router } from '@angular/router';
import { CargoGroup } from 'src/app/common/interfaces/cargo.interface';
import { ToolsService } from '@services/varios/tools.service';

@Injectable({
  providedIn: 'root'
})

export class UnidadesService {

  constructor(private readonly authService: AuthService, private readonly router:Router, private readonly toolsService: ToolsService) { }

  public async getListaUnidadesByTipoUnidad(tipo: string, idBuscado: number) : Promise<UnidadGroup[]> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getListaUnidadesByTipoUnidad?idBuscado=' + idBuscado + '&tipo=' + tipo;

    return await axios.get(BASE_URL, {
        headers: {
          Authorization: `Bearer ${UsrInfo.jwt}`,
        },
      }).then(resp => {       
          return resp.data;  
      }).catch(async error =>
        {
          if (error.response.status == 401)
          {
            sessionStorage.clear();
            await this.toolsService.errorSesionMensaje();
            this.router.navigate(['/']);
          }
        });      
    } 

    public async getListaCargosByTipoUnidad(tipo: string, idBuscado: number) : Promise<CargoGroup[]> {
      let UsrInfo = this.authService.getUserInfo();
      const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getListaCargosByTipoUnidad?idBuscado=' + idBuscado + '&tipo=' + tipo;
  
      return await axios.get(BASE_URL, {
          headers: {
            Authorization: `Bearer ${UsrInfo.jwt}`,
          },
        }).then(resp => {       
            return resp.data;  
        }).catch(async error =>
          {
            if (error.response.status == 401)
            {
              sessionStorage.clear();
              await this.toolsService.errorSesionMensaje();
              this.router.navigate(['/']);
            }
          });      
      } 
}
